<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Controleren"
      @next-step="$router.push({ name: 'scanOrderConfirm' })"
      @prev-step="$router.push({ name: 'scanOrderDeliver' })"
    ></next-prev-menu>
    <invoice
      :orderDetails="scanOrderStore.orderDetails"
      :shop="scanOrderStore.shop"
      @updateOrder="updateOrder"
      @updateProject="updateProject"
    ></invoice>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import Invoice from '@/components/Invoice.vue'
import { useScanOrderStore } from '@/features/scanOrder/ScanOrder.store'

export default {
  data() {
    return {}
  },
  components: {
    NextPrevMenu,
    Invoice
  },
  methods: {
    updateOrder(val) {
      this.scanOrderStore.updateOrderDetails(val[0], val[1])
    },
    updateProject(project) {
      this.scanOrderStore.updateProject({
        name: project.name || '',
        id: project.id || 0
      })
    }
  },
  computed: {
    ...mapStores(useScanOrderStore)
  },
  created() {}
}
</script>
